export const placeholders = {
  firstName: "employeesPage.placeholders.firstName",
  lastName: "employeesPage.placeholders.lastName",
  birthDate: "employeesPage.placeholders.birthDate",
  employmentDate: "employeesPage.placeholder.employmentDate",
  position: "employeesPage.placeholders.position",
  employeeNumber: "employeesPage.placeholders.employeeNumber",
  tachographNumber:
    "employeesPage.placeholders.tachographCardNumber",
  status: "employeesPage.placeholders.status",
};

export const copyTextToClipboard = async (text: string) => {
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand("copy", true, text);
  }
};
